import 'common/index';
import '../product/product-page.scss';
import '../product/benefits.scss';
import Review from '../review/review';
import '../contact/contact.scss';
import ProductHeader from '../product/product-header';
import ReviewReplyForm from '../product/review-reply-form';
import ProductTabs from '../product/product-tabs';
import '../product/certificates.scss';
import QuePlugin from '../product/que-plugin';
import '../product/side-blocks.scss';
import '../product/sizes-block.scss';
import OpenVideoLink from '../product/open-video-link';
import {ProductSetsList} from '../product/product-sets';
import 'jquery-zoom';

Review();
ProductHeader();
ReviewReplyForm();
ProductTabs();
QuePlugin();
OpenVideoLink();
ProductSetsList();